import { ChromeAppResponse } from 'Environment/ChromeApp/types';

export class PromiseMap {
	private promiseMap = new Map<
		string,
		{ currentResolve: Function; currentReject: Function }
	>();

	public set(correlationId: string, resolve: Function, reject: Function) {
		if (!correlationId) {
			throw new Error('Correlation ID must be provided');
		}
		this.promiseMap.set(correlationId, {
			currentResolve: resolve,
			currentReject: reject,
		});
	}

	public resolve(correlationId: string, result: ChromeAppResponse) {
		this.promiseMap.get(correlationId)?.currentResolve(result);
		this.promiseMap.delete(correlationId);
	}

	public reject(correlationId: string, error: ChromeAppResponse) {
		this.promiseMap.get(correlationId)?.currentReject(error);
		this.promiseMap.delete(correlationId);
	}

	public has(correlationId: string): boolean {
		return this.promiseMap.has(correlationId);
	}
}
